import { render, staticRenderFns } from "./CustomReview.vue?vue&type=template&id=51aac390&"
import script from "./CustomReview.vue?vue&type=script&lang=js&"
export * from "./CustomReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports